const quadras_areia = [
  'Quadra Petry Imóveis\nExclusivo Beach Tennis',
  'Quadra Varejão Rejunte\nExclusivo Beach Tennis',
  'Quadra Precisões Arquitetura\nExclusivo Beach Tennis',
  'Quadra Mauro Motta Seguros\nExclusivo Beach Tennis',
  'Quadra Vexxo\nExclusivo Futevôlei e Vôlei',
  'Quadra Brainny\nExclusivo Beach Tennis',
  'Quadra Sicredi\nExclusivo Beach Tennis',
  'Quadra Mecânica CHT\nExclusivo Beach Tennis',  
  'Quadra Homenz Estética Masculina\n',
  'Quadra Dez FM\n',
  'Quadra Numero 11\n',
];
const images_areia = [
  require('../img/petry.png'),
  require('../img/logoVarejaoOriginal.png'),
  require('../img/precisoes.png'),
  require('../img/mauro.png'),
  require('../img/vexxo.png'),
  require('../img/brainyb.png'),
  require('../img/sicredi.png'),
  require('../img/cht.png'),  
  require('../img/homenz.png'),
  require('../img/dezfm.jpg'),
  require('../img/MauroMotaLaranja.png'),
];
const quadras_padel = [
  'Quadra Precisões Arquitetura',
  'Quadra Osirnet',
  'Quadra Nissul Gala',
  'Quadra Petry Imóveis',
  'Quadra 5',

];
const images_padel = [
  require('../img/precisoes.png'),
  require('../img/osirnet.png'),
  require('../img/nissul.png'),
  require('../img/petry.png'),
  require('../img/quadra5b.png'),
];
const churrasqueiras = [
  'Churrasqueira Frigorífico Famile',
  'Churrasqueira Petry Imóveis',
  'Churrasqueira Extremo Sabor',
  'Churrasqueira 4',
  'Churrasqueira Mauro Motta Seguros',
];
const images_churrasqueiras = [
  require('../img/famile.png'),
  require('../img/petry.png'),
  require('../img/extremo_sabor.png'),
  require('../img/eleven_horizontal_grey.jpeg'),
  require('../img/mauro.png'),
];
const eleven_logo = [
  require('../img/eleven_horizontal_white.jpeg'),
  require('../img/eleven_horizontal_white.jpeg'),
  require('../img/quadras.jpeg'),
];

const quadras_pickleball = ['Quadra 1'];

const images_pickleball = [
  require('../img/eleven_horizontal_white.jpeg'),
];

export {
  churrasqueiras,
  eleven_logo,
  images_areia,
  images_churrasqueiras,
  images_padel,
  images_pickleball,
  quadras_areia,
  quadras_padel,
  quadras_pickleball,
};
